import { useQuery } from "react-query";
import { useLocation } from "react-router-dom";

import { useKy } from "src/common/ky";
import { PaginatedResult, StaffUser as StaffType } from "src/common/types";

export const GET_STAFF_LIST_QUERY_KEY = "STAFF";
export const useStaffQuery = () => {
  const ky = useKy();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);

  if (!searchParams.has("pageNumber")) {
    searchParams.set("pageNumber", "1");
  }
  searchParams.sort();

  return useQuery<PaginatedResult<StaffType>>(
    [GET_STAFF_LIST_QUERY_KEY, searchParams.toString()],
    () =>
      ky.get("staff-users", { searchParams }).json<PaginatedResult<StaffType>>()
  );
};
